// Comprehensive lazy loading implementation
(function() {
  'use strict';
  
  // Lazy loading configuration
  const LAZY_LOAD_CONFIG = {
    rootMargin: '50px 0px',
    threshold: 0.1
  };
  
  // Check if Intersection Observer is supported
  if (!('IntersectionObserver' in window)) {
    // Fallback: Load all images immediately
    const images = document.querySelectorAll('img[data-src]');
    images.forEach(img => {
      if (img.dataset.src) {
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
      }
    });
    return;
  }
  
  // Create intersection observer for lazy loading
  const imageObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;
        
        // Load the image
        if (img.dataset.src) {
          img.src = img.dataset.src;
          img.removeAttribute('data-src');
        }
        
        // Add loaded class for styling
        img.classList.add('loaded');
        
        // Stop observing this image
        observer.unobserve(img);
      }
    });
  }, LAZY_LOAD_CONFIG);
  
  // Initialize lazy loading
  function initLazyLoading() {
    // Find all images with data-src attribute
    const lazyImages = document.querySelectorAll('img[data-src]');
    
    // Start observing each lazy image
    lazyImages.forEach(img => {
      imageObserver.observe(img);
    });
    
    // Also handle images that should be lazy loaded but don't have data-src
    const allImages = document.querySelectorAll('img');
    allImages.forEach(img => {
      // Skip images that are already loaded or marked as eager
      if (img.loading === 'eager' || img.classList.contains('no-lazy')) {
        return;
      }
      
      // Skip above-the-fold images
      if (img.closest('.landing-hero') || img.closest('.hero-section')) {
        return;
      }
      
      // Set loading="lazy" for below-the-fold images
      if (img.loading !== 'lazy') {
        img.loading = 'lazy';
      }
    });
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLazyLoading);
  } else {
    initLazyLoading();
  }
  
  // Handle dynamically added images
  const mutationObserver = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) { // Element node
          if (node.tagName === 'IMG' && node.dataset.src) {
            imageObserver.observe(node);
          }
          
          // Check for images within added nodes
          const images = node.querySelectorAll && node.querySelectorAll('img[data-src]');
          if (images) {
            images.forEach(img => imageObserver.observe(img));
          }
        }
      });
    });
  });
  
  // Start observing for dynamically added content
  mutationObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
